import { useState, type ReactNode } from 'react';

interface Props {
  id?: string;
  children: ReactNode;
  align?: 'center' | 'left';
  tone?: 'gold' | 'ink';
  className?: string;
  /** Show the watercolor laurel divider beneath the title (when the asset exists). */
  laurel?: boolean;
}

export default function SectionTitle({
  id,
  children,
  align = 'center',
  tone = 'gold',
  className = '',
  laurel = true,
}: Props) {
  const [laurelOk, setLaurelOk] = useState(true);
  const color = tone === 'gold' ? 'text-brand-gold' : 'text-brand-ink';
  const alignment = align === 'center' ? 'text-center' : 'text-left';

  return (
    <div className={`${alignment} ${className}`}>
      <h2
        id={id}
        className={`font-serif font-medium uppercase tracking-widest ${color} text-2xl sm:text-3xl`}
      >
        {children}
      </h2>

      {laurel && laurelOk ? (
        <img
          src="/images/divider-laurel.jpg"
          alt=""
          aria-hidden="true"
          loading="lazy"
          onError={() => setLaurelOk(false)}
          className={`mx-auto mt-3 h-8 sm:h-10 w-auto ${align === 'left' ? 'ml-0' : ''}`}
          style={{ mixBlendMode: 'multiply' }}
        />
      ) : (
        <div
          aria-hidden="true"
          className={`mt-3 flex items-center ${align === 'left' ? 'justify-start' : 'justify-center'} gap-2`}
        >
          <span className="block h-px w-8 bg-brand-gold/60" />
          <span className="text-brand-gold text-xs">✦</span>
          <span className="block h-px w-8 bg-brand-gold/60" />
        </div>
      )}
    </div>
  );
}
